import { render, staticRenderFns } from "./RequestGridKeyPage.vue?vue&type=template&id=4c1b01ac&"
import script from "./RequestGridKeyPage.vue?vue&type=script&lang=js&"
export * from "./RequestGridKeyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports